import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["checked", "children", "className", "custom", "defaultChecked", "disabled", "icon", "iconLabelPosition", "iconSize", "inline", "inputRef", "label", "name", "onChange", "onClick", "right", "tabIndex", "value"];
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
var RadioButtonIcon = function RadioButtonIcon(props) {
  var icon = props.icon,
    iconSize = props.iconSize,
    iconLabelPosition = props.iconLabelPosition,
    text = props.text;
  var iconStyles = {
    width: "".concat(iconSize, "px"),
    height: "".concat(iconSize, "px"),
    fontSize: "".concat(iconSize, "px"),
    lineHeight: "".concat(iconSize, "px")
  };
  return /*#__PURE__*/React.createElement("span", {
    className: "radio-icon label-".concat(iconLabelPosition)
  }, /*#__PURE__*/React.createElement("span", {
    className: "rioglyph ".concat(icon),
    style: iconStyles
  }), /*#__PURE__*/React.createElement("span", {
    className: "radio-label"
  }, text));
};
var RadioButton = function RadioButton(props) {
  var checked = props.checked,
    children = props.children,
    className = props.className,
    custom = props.custom,
    defaultChecked = props.defaultChecked,
    disabled = props.disabled,
    icon = props.icon,
    iconLabelPosition = props.iconLabelPosition,
    iconSize = props.iconSize,
    inline = props.inline,
    inputRef = props.inputRef,
    label = props.label,
    name = props.name,
    onChange = props.onChange,
    onClick = props.onClick,
    right = props.right,
    tabIndex = props.tabIndex,
    value = props.value,
    remainingProps = _objectWithoutProperties(props, _excluded);
  var labelRef = useRef();
  var handleToggleKeyDown = function handleToggleKeyDown(event) {
    switch (event.keyCode) {
      case 32:
        // toggle on space
        toggle(event);
        break;
      case 13:
        // open on enter
        toggle(event);
        break;
      default:
        break;
    }
  };
  var toggle = function toggle(event) {
    event.preventDefault();
    if (disabled) {
      return;
    }

    // Controlled case - uses "onChange()" instead of "onClick()" callback
    if (checked !== null && checked !== undefined) {
      onChange(event);
      return;
    }

    // Uncontrolled case - set the input checked or unchecked
    labelRef.current.firstChild.checked = !labelRef.current.firstChild.checked;
    onClick(event);
  };
  var text = label || children;
  var labelClassnames = classNames('radio', inline && 'radio-inline', className);
  var inputClassnames = classNames(right && 'icon-right', className);
  var renderCustomIcon = !!icon;
  var renderCustomContent = custom && children;
  var renderDefault = !icon && !custom;
  return /*#__PURE__*/React.createElement("label", _extends({}, remainingProps, {
    className: labelClassnames,
    tabIndex: tabIndex,
    onKeyDown: handleToggleKeyDown,
    ref: labelRef
  }), /*#__PURE__*/React.createElement("input", {
    type: "radio",
    defaultChecked: defaultChecked,
    checked: checked,
    disabled: disabled,
    className: inputClassnames,
    ref: inputRef,
    onClick: onClick,
    onChange: onChange,
    name: name,
    value: value
  }), renderCustomIcon && /*#__PURE__*/React.createElement(RadioButtonIcon, {
    icon: icon,
    iconSize: iconSize,
    iconLabelPosition: iconLabelPosition,
    text: text
  }), renderDefault && /*#__PURE__*/React.createElement("span", {
    className: "radio-text"
  }, /*#__PURE__*/React.createElement("span", null, text)), renderCustomContent && children);
};
RadioButton.ICON_LABEL_VERTICAL = 'vertical';
RadioButton.ICON_LABEL_HORIZONTAL = 'horizontal';
RadioButton.defaultProps = {
  inline: false,
  disabled: false,
  right: false,
  custom: false,
  tabIndex: 0,
  icon: '',
  iconSize: 16,
  iconLabelPosition: RadioButton.ICON_LABEL_VERTICAL,
  onClick: function onClick() {}
};
RadioButton.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  icon: PropTypes.string,
  iconSize: PropTypes.number,
  iconLabelPosition: PropTypes.oneOf([RadioButton.ICON_LABEL_VERTICAL, RadioButton.ICON_LABEL_HORIZONTAL]),
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  defaultChecked: PropTypes.bool,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  inline: PropTypes.bool,
  right: PropTypes.bool,
  custom: PropTypes.bool,
  inputRef: PropTypes.func,
  tabIndex: PropTypes.number
};
export default RadioButton;